import { render, staticRenderFns } from "./HtmlContentBlock.vue?vue&type=template&id=58f461c0&scoped=true&"
import script from "./HtmlContentBlock.vue?vue&type=script&lang=js&"
export * from "./HtmlContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./HtmlContentBlock.vue?vue&type=style&index=0&id=58f461c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f461c0",
  null
  
)

export default component.exports